import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent, useState } from 'react';
import styles from './DeleteModal.module.scss';
import GenericDeleteModal from './GenericDeleteModal';

interface DeleteModalProps {
    title: string;
    entityName?: string;
    question?: string | JSX.Element;
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteModal: FunctionComponent<DeleteModalProps> = props => {
    const [loading, setLoading] = useState(false);

    const confirmHandler = () => {
        setLoading(true);
        props.onConfirm();
    };

    const question = props.question ? props.question : 'Are you sure you want to delete';

    const title = <span className={styles.title}>{props.title}</span>;

    const body = (
        <>
            <div className={styles.question}>{question}</div>
            <div className={styles.question}>
                <div className={styles.name}>{props.entityName}</div>?
            </div>
        </>
    );

    return (
        <GenericDeleteModal
            title={title}
            body={body}
            onConfirm={props.onConfirm}
            onCancel={props.onCancel}
            isLoading={props.isLoading}
        />
    );
};

export default DeleteModal;
